export const getData = async () => {
    const res = await fetch('/bt_topic/2021/powerofwomen/data/data.json',{
        headers: {
            'Content-Type': 'application/json'
          },
    });
    return res.json();
};
